import Entity from '@/models/entities/Entity';

export class ProductCategoryAttribute implements Entity {
  public id: number = 0;
  public title: string = '';
  public value: string | number = '';
  public type: ProductCategoryAttributeType = ProductCategoryAttributeType.STRING;
  public overrideInProduct: boolean = false;
  public keyWord: string = '';
  public hasOverriddenValue: boolean = false;

  constructor(initData: Partial<ProductCategoryAttribute>) {
    Object.assign(this, initData);
  }
}

export enum ProductCategoryAttributeType {
  STRING = 'text',
  NUMBER = 'number',
}
